import React from 'react';
import styled from 'styled-components';
import iconLink from 'assets/icons/iconLink.svg?url';

const Img = styled.div`
  background: url(${iconLink}) no-repeat center;
  height: 1.375rem;
  width: 1.375rem;
  margin-right: 0.33875rem;
  &:hover {
    transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    cursor: pointer;
  }
`;

const LinkIcon = () => {
  return (
    <Img aria-labelledby='link-icon-title'>
      <title id='link-icon-title'>Link Icon</title>
    </Img>
  );
};

export default LinkIcon;
